/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Currency {
    USD = 'USD',
    CAD = 'CAD',
}